import { isEmailInAllowlist } from "../../../common/helpers/emailAllowlist.helpers";
import { RECEIVABLES_DASHBOARD_ALLOWED_EMAILS } from "../../management-receivables/receivablesDashboardAccess";

export const TRAFFIC_FINES_DASHBOARD_ALLOWED_EMAILS =
  RECEIVABLES_DASHBOARD_ALLOWED_EMAILS;

export function canAccessTrafficFinesDashboard(
  email: string | undefined,
): boolean {
  return isEmailInAllowlist(email, TRAFFIC_FINES_DASHBOARD_ALLOWED_EMAILS);
}
